import { render, staticRenderFns } from "./CardBind.vue?vue&type=template&id=6bf157bb&"
import script from "./CardBind.vue?vue&type=script&lang=js&"
export * from "./CardBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports